import { FetchMethod, useCodeerApi } from "../useCodeerApi"
import { Identity, Response } from "@/types"

export interface FormRequestSubmissionResponse {
  id: string
  history_id: number
  workspace_id?: string | null
  schema_id?: string | null
  schema_title?: string | null
  agent_id?: string | null
  agent_name?: string | null
  submitted_identity?: {
    kind: Identity["kind"]
    user_id?: number | null
    user_email?: string | null
    user_name?: string | null
    external_user_id?: string | null
  } | null
  submitted_at?: string | null
  submission: Record<string, unknown>
}

export const useGetFormRequestsApi = () => {
  return useCodeerApi<Response<FormRequestSubmissionResponse[]>>(
    "/form-requests",
    FetchMethod.Get
  )
}

export interface FormRequestSchemaOptionResponse {
  schema_id: string
  schema_title?: string | null
}

export const useGetFormRequestSchemasApi = () => {
  return useCodeerApi<Response<FormRequestSchemaOptionResponse[]>>(
    "/form-requests/schemas",
    FetchMethod.Get
  )
}
